import { useEffect } from 'react'
import SearchForm from 'components/Search/SearchForm'
import { useGlobalHotelsSearchContext } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalHotelsSearch'
import GlobalSearchContextProvider from 'contexts/GlobalSearch/GlobalSearchContextProvider'
import { GLOBAL_SEARCH_INITIAL_STATE, GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import { useLocation } from 'react-router-dom'
import Pane from 'components/Common/Pane'
import styled from 'styled-components'
import { rem } from 'polished'
import { getDestinationLandingSearchItem } from './getDestinationLandingSearchItem'

const StyledPane = styled(Pane)`
  padding: ${rem(16)};
`

function DesktopSearch() {
  const { globalHotelsSearchDispatch, globalHotelsSearchState } = useGlobalHotelsSearchContext({
    ...GLOBAL_SEARCH_INITIAL_STATE,
  })
  const { pathname } = useLocation()

  useEffect(() => {
    const searchItem = getDestinationLandingSearchItem(pathname)
    if (!searchItem) return

    globalHotelsSearchDispatch({
      type: GlobalSearchStateActions.SET_SEARCH_ITEM,
      searchItem,
    })
  }, [globalHotelsSearchDispatch, pathname])

  return (
    <StyledPane>
      <GlobalSearchContextProvider state={globalHotelsSearchState} dispatch={globalHotelsSearchDispatch}>
        <SearchForm submitOnApply />
      </GlobalSearchContextProvider>
    </StyledPane>
  )
}

export default DesktopSearch
